"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var PropTypes = require("prop-types");
var StarFilledIcon_1 = require("../Icons/StarFilledIcon");
var nodash_1 = require("../../utils/nodash");
var propTypes = {
    value: function (props, propName) {
        if (props[propName] < 0) {
            return new Error('value must be a positive number');
        }
        if (props[propName] > props.max) {
            return new Error('value must be in range of 0 and the max value');
        }
    },
    max: function (props, propName) {
        if (props[propName] <= 0) {
            return new Error('max value must be greater than 0');
        }
    },
    heightInPixel: function (props, propName) {
        if (props[propName] <= 0) {
            return new Error('heightInPixel must be greater than 0');
        }
    },
    children: PropTypes.element,
    className: PropTypes.string
};
var defaultProps = {
    value: 0,
    max: 5,
    heightInPixel: 22,
    children: undefined,
    className: undefined
};
/**
 * This component displays a star rating.
 */
exports.StarRating = function (props) {
    var children = props.children, className = props.className, heightInPixel = props.heightInPixel, value = props.value, max = props.max, other = __rest(props, ["children", "className", "heightInPixel", "value", "max"]);
    var componentClassName = classNames('ee_star-rating', className);
    return (React.createElement("span", __assign({}, other, { className: componentClassName, style: {
            height: heightInPixel + 'px',
            width: max * heightInPixel + 'px'
        } }),
        React.createElement("span", { className: "ee_star-rating__stars", "aria-hidden": "true" }, nodash_1.range(0, max).map(function (key) { return (React.createElement(StarFilledIcon_1.default, { key: key, width: heightInPixel, height: heightInPixel, className: "ee_star-rating__star", "aria-hidden": "true" })); })),
        React.createElement("span", { className: "ee_star-rating__stars", style: { width: value * heightInPixel + 'px' }, "aria-label": value + " von " + max + " Sternen" }, nodash_1.range(0, max).map(function (key) { return (React.createElement(StarFilledIcon_1.default, { key: key, width: heightInPixel, height: heightInPixel, className: "ee_star-rating__star--filled", "aria-hidden": "true" })); }))));
};
exports.StarRating.displayName = 'StarRating';
exports.StarRating.defaultProps = defaultProps;
exports.StarRating.propTypes = propTypes;
exports.default = exports.StarRating;
//# sourceMappingURL=StarRating.js.map